import { RootState } from '@core/store/rootReducer';
import { createSelector } from '@reduxjs/toolkit';
import { preferencesReducer } from './PreferencesReducer';

const preferencesState = (state: RootState) => state.preferences;

export const preferencesSelector = createSelector([preferencesState], (state) => {
  return {
    ...state,
    preferences: preferencesReducer.entityAdapter.getSelectors().selectById(state, 1) ?? null,
    loading: state.loadingPending > 0,
  };
});
